import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store'
import {AUTH_ERROR} from '@/store/actions'

Vue.use(VueAxios, axios)

window.axios = require('axios')
axios.defaults.baseURL = process.env.VUE_APP_API_HOST
axios.interceptors.response.use(undefined, (error) => {
  if (error.response && error.response.status === 401) {
    store.dispatch(AUTH_ERROR)
      .then(() => {
        store.commit('modalAuthError', true)
      })
  }
  return Promise.reject(error)
})

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js